// utils/cache.jsx

export const setCache = (key, data, expiryInMinutes) => {
    const item = {
      data,
      expiry: new Date().getTime() + expiryInMinutes * 60000
    };
    localStorage.setItem(key, JSON.stringify(item));
  };
  
  export const getCache = (key) => {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) return null;
  
    const item = JSON.parse(itemStr);
    if (new Date().getTime() > item.expiry) {
      localStorage.removeItem(key);
      return null;
    }
    return item.data;
  };
  
  export const clearCache = (key) => {
    localStorage.removeItem(key);
  };
  